"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pelican2 = exports.Catalogue = exports.State = exports.LatestTelemetryUpdate = exports.Telemetry = exports.SensorIdentifier = exports.SERVING_SIZES = exports.SERVING_SIZE_EU = exports.SERVING_SIZE_US = exports.NAMESPACE = exports.Remote = exports.Command = exports.Prefs = exports.Msn = exports.Chiller = void 0;
const effect_1 = require("effect");
const cellular_1 = require("../../../../network/cellular");
const Unit = __importStar(require("../../../../unit"));
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const Chiller = __importStar(require("./chiller"));
const command_1 = require("./command");
const failure_mode_1 = require("./failure-mode");
const Msn = __importStar(require("./msn"));
const Prefs = __importStar(require("./prefs"));
exports.Chiller = __importStar(require("./chiller"));
exports.Msn = __importStar(require("./msn"));
exports.Prefs = __importStar(require("./prefs"));
exports.Command = __importStar(require("./command"));
exports.Remote = __importStar(require("./remote"));
exports.NAMESPACE = 'Culligan.Device.Class.Pelican2';
exports.SERVING_SIZE_US = Unit.Volume.UsFluidOunce.make({ amount: 12 });
exports.SERVING_SIZE_EU = Unit.Volume.Milliliter.make({ amount: 330 });
exports.SERVING_SIZES = [
    exports.SERVING_SIZE_US,
    exports.SERVING_SIZE_EU,
];
const operatingModes = [
    'Disabled',
    'Factory',
    'Fault',
    'Installation',
    'Ota',
    'Standard',
    'Startup',
    'Service',
];
const powerProfiles = ['Standard', 'Eco', 'Sleep'];
const logLevels = ['Debug', 'Silent', 'Warning', 'Trace'];
const connectivity = ['Cellular', 'Wi-Fi', 'Ethernet'];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
const events = [capability_1.Event.DrinkDispensed, capability_1.Event.DispenseFailed, capability_1.Event.RadioSurvey];
const alarmingSensors = ['ht_wt', 'd_open', 'u_pres', 'ct_wt'];
const slots = [
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.LiquidEnhancement.LiquidEnhancement],
    [capability_1.Consumable.Definition.PreCarbonBlockFilter.PreCarbonBlockFilter],
    [
        capability_1.Consumable.Definition.CarbonBlockFilter.CarbonBlockFilter,
        capability_1.Consumable.Definition.MicroPurityFilter.MicroPurityFilter, // Only used when units are serviced by Zip
    ],
    [capability_1.Consumable.Definition.LimescaleFilter.LimescaleFilter],
    [capability_1.Consumable.Definition.UVCLight.UVCLight],
    [capability_1.Consumable.Definition.CO2Tank.CO2Tank],
];
const alarms = {
    consumableBased: [
        capability_1.Alarm.ConsumableDepleted,
        capability_1.Alarm.ConsumableExpired,
        capability_1.Alarm.ConsumableLowLevel,
        capability_1.Alarm.ConsumableOverused,
    ],
    firmwareBased: [
        capability_1.Alarm.NWtr,
        capability_1.Alarm.HotNTC,
        capability_1.Alarm.IceBathIceThickness,
        capability_1.Alarm.FlowMeterExceed,
        capability_1.Alarm.SafetyTimeout,
    ],
    telemetryBased: [capability_1.Alarm.OutOfRange, capability_1.Alarm.DripFull, capability_1.Alarm.LeakBottom],
};
const commands = [
    ...capability_1.Command.systemCommands,
    ...command_1.commands,
];
const sensors = {
    u_pres: capability_1.Telemetry.Sensor.Boolean({
        name: 'User presence',
        type: capability_1.Telemetry.UserPresence,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Boolean({ value: false }),
    }),
    ct_wt: capability_1.Telemetry.Sensor.Number({
        name: 'Cold tank water temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 0, max: 10 }),
    }),
    ht_wt: capability_1.Telemetry.Sensor.Number({
        name: 'Hot tank water temperature',
        type: capability_1.Telemetry.WaterTemperature,
        expectedValue: capability_1.Telemetry.ExpectedSensorValue.Range({ min: 55, max: 92 }),
    }),
    ov_wd_fb: capability_1.Telemetry.Sensor.Number({
        name: 'Overall water dispensed',
        type: capability_1.Telemetry.WaterDispensed,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    d_open: capability_1.Telemetry.Sensor.Boolean({
        name: 'Door open',
        type: capability_1.Telemetry.DoorOpen,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    uv_out: capability_1.Telemetry.Sensor.Boolean({
        name: 'UV OUT enabled',
        type: capability_1.Telemetry.ComponentEnabled,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    lk_gnd: capability_1.Telemetry.Sensor.Boolean({
        name: 'Ground leak detected',
        type: capability_1.Telemetry.LeakDetected,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    drip_s: capability_1.Telemetry.Sensor.Boolean({
        name: 'Drip tray full',
        type: capability_1.Telemetry.DripTrayFull,
        expectedValue: capability_1.Telemetry.ExpectFalse,
    }),
    network_rssi: capability_1.Telemetry.Sensor.Number({
        name: 'Network RSSI',
        type: capability_1.Telemetry.SignalStrength,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
};
const sku = '830';
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
exports.Telemetry = effect_1.Schema.Struct({
    u_pres: capability_1.Telemetry.UserPresence.FromScalar,
    ct_wt: capability_1.Telemetry.WaterTemperature.FromScalar,
    ht_wt: capability_1.Telemetry.WaterTemperature.FromScalar,
    ov_wd_fb: capability_1.Telemetry.WaterDispensed.FromScalar,
    d_open: capability_1.Telemetry.DoorOpen.FromScalar,
    uv_out: capability_1.Telemetry.ComponentEnabled.FromScalar,
    lk_gnd: capability_1.Telemetry.LeakDetected.FromScalar,
    drip_s: capability_1.Telemetry.DripTrayFull.FromScalar,
    network_rssi: capability_1.Telemetry.SignalStrength.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({ key: exports.SensorIdentifier, value: effect_1.Schema.DateFromNumber })
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    iccid: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(cellular_1.Iccid), { exact: true }),
    location: effect_1.Schema.optionalWith(Base.NullableDetectedLocation, { exact: true }),
    uiVersion: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    batch: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.Literal(sku), { exact: true }),
    msn: effect_1.Schema.optionalWith(Msn.Msn, { exact: true, nullable: true }),
    // Null is a unit reporting no chiller connected, which absent does not say.
    chiller: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Chiller.Info), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
const identifier = `${exports.NAMESPACE}.Pelican2`;
/**
 * @author Alex Wright - Lead Hardware Engineer <alex.wright@culligan.com>
 * @author Glenn Kroeze - Lead Frontend Developer <glenn.kroeze@culligan.com>
 * @author Alessio Miani - Lead Firmware Developer <a.miani@cemegroup.com>
 */
class Pelican2 extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('fbfc'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(Prefs.Prefs, { exact: true, default: () => Prefs.DEFAULT_PREFS }),
    vendor: vendor_1.Quench.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'fbfc';
    static label = 'Twist';
    static category = 'Dispenser';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static alarms = alarms;
    static slots = slots;
    static sensors = sensors;
    static events = events;
    static commands = commands;
    static connectivity = connectivity;
    static connectionGateway = 'AzureIotHub';
    static image = null;
    static State = exports.State;
    static Prefs = Prefs.Prefs;
    static PrefsFromPartial = Prefs.PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.Quench.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Startup',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Cellular',
        }, slots, sku, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        const liquidEnhancementSlotIndices = [0, 1, 2, 3, 4, 5, 6, 7];
        const liquidEnhancementAlarms = effect_1.Array.flatMapNullable(liquidEnhancementSlotIndices, slotIndex => {
            const consumable = this.consumables[slotIndex];
            return ((0, _util_1.checkAlarmOnDepletableConsumable)(consumable, slotIndex) ??
                (0, _util_1.checkAlarmOnExpirableConsumable)(consumable, slotIndex));
        });
        const slotNineAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[8], 8);
        const slotTenAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[9], 9) ??
            (0, _util_1.checkAlarmOnExpirableConsumable)(this.consumables[9], 9);
        const slotElevenAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[10], 10);
        const slotTwelveAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[11], 11);
        const slotThirteenAlarm = (0, _util_1.checkAlarmOnDepletableConsumable)(this.consumables[12], 12);
        return [
            ...liquidEnhancementAlarms,
            ...[slotNineAlarm, slotTenAlarm, slotElevenAlarm, slotTwelveAlarm, slotThirteenAlarm].filter(s => s !== null),
        ];
    }
    get telemetryAlarms() {
        const outOfRangeAlarms = effect_1.Array.flatMapNullable(alarmingSensors, sensorId => {
            const measurement = this.latestTelemetry[sensorId];
            if (!measurement)
                return;
            if (capability_1.Telemetry.meetsExpectation(sensors[sensorId], measurement))
                return;
            return new capability_1.Alarm.OutOfRange({
                params: {
                    telemetryId: sensorId,
                    value: measurement.value,
                },
            });
        });
        const sensorBasedAlarms = [];
        if (this.latestTelemetry.drip_s?.value) {
            sensorBasedAlarms.push(new capability_1.Alarm.DripFull());
        }
        if (this.latestTelemetry.lk_gnd?.value) {
            sensorBasedAlarms.push(new capability_1.Alarm.LeakBottom());
        }
        return [...outOfRangeAlarms, ...sensorBasedAlarms];
    }
    get manufacturingInfo() {
        return (0, effect_1.pipe)(this.state.msn, effect_1.Option.fromNullable, effect_1.Option.flatMap(effect_1.Schema.decodeOption(Msn.ManufacturingInfoFromMsn)));
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.Pelican2 = Pelican2;
//# sourceMappingURL=index.js.map